import React, { Component } from 'react';

import BrowserDetection from 'react-browser-detection';
import BrowserHandler from '../../utils/browser-handler';
import ThemeSelector from '../../themes/theme-selector';

const theme = ThemeSelector.theme();

class CheckLocalStorage extends Component {
  render() {
    return (
      <div className="page-centered">
        <div className="center-outer">
          <div className="center-inner">
            <div className="center-logo">
              <a onClick={() => this.context.router.push('/')}>
                <img src={theme.darkLogo.src} alt={theme.darkLogo.alt} />
              </a>
            </div>

            <div className="browser-detect">

              <div className="browser-warning">
                <p className="info">Oops... we need to use local storage.</p>
                <p className="info">If you are using Safari please switch off Private Mode.</p>

                <br />

                <BrowserDetection>
                  {BrowserHandler.handle}
                </BrowserDetection>
              </div>

            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default CheckLocalStorage;



/** WEBPACK FOOTER **
 ** ./src/containers/check-local-storage/index.js
 **/